<template>
  <b-modal
    id="delete-ad-modal"
    title="Delete AD"
  >
    <h4 class="text-center">
      Are you sure you want to delete this AD?
    </h4>
    <template #modal-footer="{close}">
      <b-row style="width:100%">
        <b-col md="6">
          <b-button
            block
            variant="danger"
            @click="close"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col md="6">
          <b-button
            block
            variant="primary"
            :disabled="submitting"
            @click="deleteHandler(close)"
          >
            <BSpinner
              v-if="submitting"
              small
            />
            <span v-else>Confirm</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BButton, BSpinner, BRow, BCol,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BModal, BButton, BSpinner, BRow, BCol,
  },
  props: {
    screenId: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    const submitting = ref(false)
    const deleteHandler = async closeFn => {
      submitting.value = true
      await ctx.root.$store.dispatch('ads/deleteAd', {
        adId: props.id,
        screenId: props.screenId,
      })
      closeFn()
      ctx.emit('deleted')
      submitting.value = false
    }
    return {
      submitting,
      deleteHandler,
    }
  },
}
</script>

  <style>

  </style>
